import { SidebarItem } from '../types/sidebar-conversation';

export const conversations: SidebarItem[] = [
  {
    ConversationId: '1',
    ConversationTitle: 'Today Conversation 1',
    CreatedBy: 'user-1',
    TenantId: 'tenant-1',
    CreatedDate: '2025-04-27T10:00:00.000Z',
    LastUpdatedDate: '2025-04-27T10:00:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '2',
    ConversationTitle: 'Today Conversation 2',
    CreatedBy: 'user-1',
    TenantId: 'tenant-1',
    CreatedDate: '2025-04-27T12:00:00.000Z',
    LastUpdatedDate: '2025-04-27T12:00:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '3',
    ConversationTitle: 'Yesterday Conversation',
    CreatedBy: 'user-2',
    TenantId: 'tenant-1',
    CreatedDate: '2025-04-26T14:00:00.000Z',
    LastUpdatedDate: '2025-04-26T14:00:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '4',
    ConversationTitle: 'Last Week Conversation 1',
    CreatedBy: 'user-3',
    TenantId: 'tenant-1',
    CreatedDate: '2025-04-24T09:00:00.000Z',
    LastUpdatedDate: '2025-04-24T09:00:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '5',
    ConversationTitle: 'Last Week Conversation 2',
    CreatedBy: 'user-3',
    TenantId: 'tenant-1',
    CreatedDate: '2025-04-22T16:30:00.000Z',
    LastUpdatedDate: '2025-04-22T16:30:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '6',
    ConversationTitle: 'Last 30 Days Conversation 1',
    CreatedBy: 'user-4',
    TenantId: 'tenant-1',
    CreatedDate: '2025-04-10T11:15:00.000Z',
    LastUpdatedDate: '2025-04-10T11:15:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '7',
    ConversationTitle: 'March 2025 Conversation',
    CreatedBy: 'user-5',
    TenantId: 'tenant-1',
    CreatedDate: '2025-03-15T10:00:00.000Z',
    LastUpdatedDate: '2025-03-15T10:00:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '8',
    ConversationTitle: 'February 2025 Conversation',
    CreatedBy: 'user-5',
    TenantId: 'tenant-1',
    CreatedDate: '2025-02-20T08:30:00.000Z',
    LastUpdatedDate: '2025-02-20T08:30:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '9',
    ConversationTitle: 'January 2025 Conversation',
    CreatedBy: 'user-6',
    TenantId: 'tenant-1',
    CreatedDate: '2025-01-10T13:00:00.000Z',
    LastUpdatedDate: '2025-01-10T13:00:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '10',
    ConversationTitle: 'December 2024 Conversation',
    CreatedBy: 'user-7',
    TenantId: 'tenant-1',
    CreatedDate: '2024-12-25T18:45:00.000Z',
    LastUpdatedDate: '2024-12-25T18:45:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '11',
    ConversationTitle: 'November 2024 Conversation',
    CreatedBy: 'user-7',
    TenantId: 'tenant-1',
    CreatedDate: '2024-11-18T20:30:00.000Z',
    LastUpdatedDate: '2024-11-18T20:30:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '12',
    ConversationTitle: 'October 2024 Conversation',
    CreatedBy: 'user-8',
    TenantId: 'tenant-1',
    CreatedDate: '2024-10-05T15:00:00.000Z',
    LastUpdatedDate: '2024-10-05T15:00:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '13',
    ConversationTitle: 'Year 2024 Conversation',
    CreatedBy: 'user-9',
    TenantId: 'tenant-1',
    CreatedDate: '2024-04-10T10:30:00.000Z',
    LastUpdatedDate: '2024-04-10T10:30:00.000Z',
    Conversations: [],
  },
  {
    ConversationId: '14',
    ConversationTitle: 'Year 2023 Conversation',
    CreatedBy: 'user-9',
    TenantId: 'tenant-1',
    CreatedDate: '2023-06-20T11:15:00.000Z',
    LastUpdatedDate: '2023-06-20T11:15:00.000Z',
    Conversations: [],
  },
];

export const months: string[] = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
];
